// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PatientAccountGetCaseDefaultResponse {
    static getAttributeTypeMap() {
        return PatientAccountGetCaseDefaultResponse.attributeTypeMap;
    }
}
PatientAccountGetCaseDefaultResponse.discriminator = undefined;
PatientAccountGetCaseDefaultResponse.additionalProperties = false;
PatientAccountGetCaseDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "GetCaseResponseModel"
    },
];
//# sourceMappingURL=patientAccountGetCaseDefaultResponse.js.map